export default "__VITE_ASSET__BFqpPZgt__"